
        <div class="modal-body pt-2 pb-2 pl-0 pr-0">
                <div class="ps position-relative pl-3 pr-3" [perfectScrollbar]="config" style="max-height: calc(100vh - 10.5rem);">
                    <p class="fnt-size14px mb-2">{{nudge_data?.products[0].course_name}}</p>
                    <p class="fnt-size14px text-medium-grey mb-2">{{nudge_data?.products[0].course_summary | slice:0:100 }} {{(nudge_data?.products[0].course_summary.length>100)? '...':''}}</p>
                    <div class="p-2 border rounded mb-3">
                            <app-web-cme-card  [cmeObj]="nudge_data?.products[0]" ></app-web-cme-card>
                    </div>
                    <div class="border-top pt-3">
                        <p class="fnt-size12px fnt-weight500 text-medium-grey mb-2">you may interested</p>
                        <app-common-suggestion *ngIf='suggestionObj !=undefined' [suggestionObj]=suggestionObj></app-common-suggestion>
   
                    </div>
                </div>
        </div> 
